/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { moduleName } from '../utils/Manager';

export default function DocumentationType({ type = { type: "unknown" } }) {
    switch (type.type) {
        case "reference":
            const elements = [<a href={urlFromReferenceName(type.name, !!type.id)}>{type.name}</a>];
            if (type.typeArguments) elements.push(<TypeArguments args={type.typeArguments}/>)
            return elements;

        case "array": return [<DocumentationType type={type.elementType}/>, <strong>[]</strong>];
        case "intrinsic": return <a href={`https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/${type.name}`}>{type.name}</a>
        case "literal": return <a href="javascript:void(0)">{`"${type.value}"`}</a>
        case "union": 
            let li = type.types.length - 1;
            return type.types.map((t, i) => <><DocumentationType type={t}/>{i == li ? null : <strong>{' | '}</strong>}</>);

        case "typeOperator": return [<strong>{type.operator}</strong>, ' ', <DocumentationType type={type.target}/>]
        case "unknown": return <a href="https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-0.html#new-unknown-top-type">unknown</a>
        case "reflection":
            if (type.declaration.kindString === "Type literal") {
                if (type.declaration.signatures) return <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function">Function</a>;
                return [<strong>{'{ '}</strong>, type.declaration.children.map(prop => [
                    <strong>{prop.name}</strong>, 
                    prop.flags.isOptional ? '?: ' : ': ', 
                    <DocumentationType type={prop.type}/>,
                    <strong>, </strong>
                ]), <strong>{' }'}</strong>];
            } else throw type;

        case "tuple":
            let tli = type.elements.length - 1;
            return [<strong>[</strong>, type.elements.map((e, i) => [<DocumentationType type={e}/>, i == tli ? null : <strong>, </strong>]), <strong>]</strong>];

        case "template-literal":
            const tlElements = [type.head];
            for (const i of type.tail[0]) 
                tlElements.push(typeof i == "string" ? <>{i}</> : <>{'${'}<DocumentationType type={i}/>{'}'}</>);

            return <a href="javascript:void(0)">{'"'}{tlElements}{'"'}</a>;
        
        case "conditional":
            const conditionalElements = [<DocumentationType type={type.checkType}/>];
            if (type.extendsType) conditionalElements.push(<strong> extends </strong>, <DocumentationType type={type.extendsType}/>);
            conditionalElements.push(<strong> ? </strong>, <DocumentationType type={type.trueType}/>, <strong> : </strong>, <DocumentationType type={type.falseType}/>);
            return conditionalElements;

        case "intersection":
            return [<DocumentationType type={type.types[0]}/>, <strong>{' & '}</strong>, <DocumentationType type={type.types[1]}/>];
        
        case "mapped": return <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object">Object</a>;
        case "inferred": return type.name;

        default: throw type
    }
}

export function TypeArguments({ args }) {
    let li = args.length - 1;

    return <>
        <strong>{'<'}</strong>
        {args.map((t, i) => [<DocumentationType type={t}/>, i == li ? null : <strong>, </strong>])}
        <strong>{'>'}</strong>
    </>
}

function urlFromReferenceName(name, hasID) {
    let docs = window.pages.docs[moduleName];

    if (moduleName == "apiTypes" && hasID) {
        if (docs.interface[name]) return `/${moduleName}/interface/${name}`;
        if (docs.typeAlias[name]) return `/${moduleName}/typeAlias/${name}`;
    } else if (moduleName == "main") {
        if (hasID) {
            if (docs.interface[name]) return `/main/interface/${name}`;
            if (docs.typeAlias[name]) return `/main/typeAlias/${name}`;
            if (docs.class[name]) return `/main/class/${name}`;
            if (docs.enum[name]) return `/main/enum/${name}`;
        }
        
        docs = window.pages.docs['apiTypes'];
        if (docs.interface[name]) return `/apiTypes/interface/${name}`;
        if (docs.typeAlias[name]) return `/apiTypes/typeAlias/${name}`;
    }
    
    return 'javascript:void(0)';
}